<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index, 'edit')">
                  <v-icon @click="goTo(data.item, data.index, 'edit')"
                    >edit</v-icon
                  >
                </v-btn>
              </template>
              <template v-slot:cell(CLASSTIME)="data">
                <div v-html="data.item.CLASSTIME">
                  {{ data.item.CLASSTIME }}
                </div>
              </template>
              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="isEdit == true">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.educationLvl") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selLvl }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.classId") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.COURSECODE }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.className") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.COURSENAMEENG }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.section") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SECTION }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="handleSaveApproveLate()"
                >
                  {{ $t("messages.general.save") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div>
            <v-tabs v-model="selTab">
              <v-tab href="#tab-pendingApprove">{{
                $t("messages.general.pendingApproval")
              }}</v-tab>
              <v-tab href="#tab-approve">{{
                $t("messages.general.approve")
              }}</v-tab>
              <v-tab href="#tab-disapprove">{{
                $t("messages.general.disapproved")
              }}</v-tab>
              <v-tab-item value="tab-pendingApprove">
                <v-card flat>
                  <v-card-text>
                    <v-sheet>
                      <v-card
                        style="height: 350px; overflowX: auto; position: relative;"
                      >
                        <b-table
                          bordered
                          hover
                          small
                          responsive
                          caption-top
                          class="table table-striped text-center"
                          :sort-by.sync="bTableStudentPendingApproval.sortBy"
                          :sort-desc.sync="
                            bTableStudentPendingApproval.sortDesc
                          "
                          :items="bTableStudentPendingApproval.items"
                          :fields="bTableStudentPendingApproval.fields"
                          :per-page="perPage"
                          :current-page="currentPageStudent"
                          style="position: relative; overflowY: hidden; padding-bottom: 55px"
                        >
                          <template slot="table-caption">
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="
                                bTableStudentPendingApproval.items.length
                              "
                              v-model="currentPageStudent"
                              :per-page="perPage"
                            />
                            <div
                              v-if="
                                bTableStudentPendingApproval.items.length > 0
                              "
                              class="float-right data-table-page-info"
                            >
                              {{
                                Number(
                                  currentPageStudent > 1
                                    ? (currentPageStudent - 1) * perPage + 1
                                    : currentPageStudent
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPageStudent * perPage >
                                    bTableStudentPendingApproval.items.length
                                    ? bTableStudentPendingApproval.items.length
                                    : currentPageStudent * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentPendingApproval.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="
                                bTableStudentPendingApproval.items.length <= 0
                              "
                              class="float-right data-table-page-info"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentPendingApproval.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </template>
                          <template v-slot:head(action)="">
                            <label>{{ $t("messages.general.approve") }}</label
                            ><br />
                            <input
                              type="checkbox"
                              id="chkPStudentAll"
                              @change="handleChkAllPending($event)"
                              :checked="
                                bTableStudentPendingApproval.items.length > 0 &&
                                  bTableStudentPendingApproval.items.length ==
                                    studentPendingList.length
                              "
                            />
                          </template>
                          <template v-slot:cell(action)="data">
                            <input
                              type="checkbox"
                              id="chkPStudent"
                              @change="handleChkPending($event, data)"
                              :checked="data.item.selCheck"
                            />
                          </template>
                          <template v-slot:cell(STUDENTCODE)="data">
                            <label v-if="data.item.RESERVECODE == 0">{{
                              data.item.STUDENTCODE
                            }}</label>
                            <label v-else style="color: red;">{{
                              data.item.STUDENTCODE
                            }}</label>
                          </template>
                          <template slot="table-caption">
                            <div
                              style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                            >
                              <div class="float-left">
                                <b class="mr-2">{{
                                  $t("messages.general.table.paginationinfo")
                                }}</b>
                                <b-form-select
                                  v-model="perPage"
                                  :options="perPageOptions"
                                  size="sm"
                                  style="width:70px"
                                />
                              </div>
                              <b-pagination
                                class="float-right"
                                size="sm"
                                :total-rows="
                                  bTableStudentPendingApproval.items.length
                                "
                                v-model="currentPageStudent"
                                :per-page="perPage"
                                style="padding-top: 10px"
                              />
                              <div
                                v-if="
                                  bTableStudentPendingApproval.items.length > 0
                                "
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                {{
                                  Number(
                                    currentPageStudent > 1
                                      ? (currentPageStudent - 1) * perPage + 1
                                      : currentPageStudent
                                  ).toLocaleString()
                                }}
                                -
                                {{
                                  Number(
                                    currentPageStudent * perPage >
                                      bTableStudentPendingApproval.items.length
                                      ? bTableStudentPendingApproval.items
                                          .length
                                      : currentPageStudent * perPage
                                  ).toLocaleString()
                                }}
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentPendingApproval.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                              <div
                                v-if="
                                  bTableStudentPendingApproval.items.length <= 0
                                "
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                0 - 0
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentPendingApproval.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </v-card>
                    </v-sheet>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-approve">
                <v-card flat>
                  <v-card-text>
                    <v-sheet>
                      <v-card
                        style="height: 350px; overflowX: auto; position: relative;"
                      >
                        <b-table
                          bordered
                          hover
                          small
                          responsive
                          caption-top
                          class="table table-striped text-center"
                          :sort-by.sync="bTableStudentApprove.sortBy"
                          :sort-desc.sync="bTableStudentApprove.sortDesc"
                          :items="bTableStudentApprove.items"
                          :fields="bTableStudentApprove.fields"
                          :per-page="perPage"
                          :current-page="currentPageStudent"
                          style="position: relative; overflowY: hidden; padding-bottom: 55px"
                        >
                          <template slot="table-caption">
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableStudentApprove.items.length"
                              v-model="currentPageStudent"
                              :per-page="perPage"
                            />
                            <div
                              v-if="bTableStudentApprove.items.length > 0"
                              class="float-right data-table-page-info"
                            >
                              {{
                                Number(
                                  currentPageStudent > 1
                                    ? (currentPageStudent - 1) * perPage + 1
                                    : currentPageStudent
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPageStudent * perPage >
                                    bTableStudentApprove.items.length
                                    ? bTableStudentApprove.items.length
                                    : currentPageStudent * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentApprove.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableStudentApprove.items.length <= 0"
                              class="float-right data-table-page-info"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentApprove.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </template>

                          <template v-slot:cell(actionBin)="data">
                            <v-btn text icon @click="pendingForApprove(data)">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>

                          <template v-slot:cell(action)="data">
                            <input type="checkbox" checked disabled />
                          </template>

                          <template v-slot:cell(STUDENTCODE)="data">
                            <label v-if="data.item.RESERVECODE == 0">{{
                              data.item.STUDENTCODE
                            }}</label>
                            <label v-else style="color: red;">{{
                              data.item.STUDENTCODE
                            }}</label>
                          </template>

                          <template slot="table-caption">
                            <div
                              style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                            >
                              <div class="float-left">
                                <b class="mr-2">{{
                                  $t("messages.general.table.paginationinfo")
                                }}</b>
                                <b-form-select
                                  v-model="perPage"
                                  :options="perPageOptions"
                                  size="sm"
                                  style="width:70px"
                                />
                              </div>
                              <b-pagination
                                class="float-right"
                                size="sm"
                                :total-rows="bTableStudentApprove.items.length"
                                v-model="currentPageStudent"
                                :per-page="perPage"
                                style="padding-top: 10px"
                              />
                              <div
                                v-if="bTableStudentApprove.items.length > 0"
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                {{
                                  Number(
                                    currentPageStudent > 1
                                      ? (currentPageStudent - 1) * perPage + 1
                                      : currentPageStudent
                                  ).toLocaleString()
                                }}
                                -
                                {{
                                  Number(
                                    currentPageStudent * perPage >
                                      bTableStudentApprove.items.length
                                      ? bTableStudentApprove.items.length
                                      : currentPageStudent * perPage
                                  ).toLocaleString()
                                }}
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentApprove.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                              <div
                                v-if="bTableStudentApprove.items.length <= 0"
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                0 - 0
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentApprove.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </v-card>
                    </v-sheet>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-disapprove">
                <v-card flat>
                  <v-card-text>
                    <v-sheet>
                      <v-card
                        style="height: 350px; overflowX: auto; position: relative;"
                      >
                        <b-table
                          bordered
                          hover
                          small
                          responsive
                          caption-top
                          class="table table-striped text-center"
                          :sort-by.sync="bTableStudentDisApprove.sortBy"
                          :sort-desc.sync="bTableStudentDisApprove.sortDesc"
                          :items="bTableStudentDisApprove.items"
                          :fields="bTableStudentDisApprove.fields"
                          :per-page="perPage"
                          :current-page="currentPageStudent"
                          style="position: relative; overflowY: hidden; padding-bottom: 55px"
                        >
                          <template slot="table-caption">
                            <div class="float-left">
                              <b class="mr-2">{{
                                $t("messages.general.table.paginationinfo")
                              }}</b>
                              <b-form-select
                                v-model="perPage"
                                :options="perPageOptions"
                                size="sm"
                                style="width:70px"
                              />
                            </div>
                            <b-pagination
                              class="float-right"
                              size="sm"
                              :total-rows="bTableStudentDisApprove.items.length"
                              v-model="currentPageStudent"
                              :per-page="perPage"
                            />
                            <div
                              v-if="bTableStudentDisApprove.items.length > 0"
                              class="float-right data-table-page-info"
                            >
                              {{
                                Number(
                                  currentPageStudent > 1
                                    ? (currentPageStudent - 1) * perPage + 1
                                    : currentPageStudent
                                ).toLocaleString()
                              }}
                              -
                              {{
                                Number(
                                  currentPageStudent * perPage >
                                    bTableStudentDisApprove.items.length
                                    ? bTableStudentDisApprove.items.length
                                    : currentPageStudent * perPage
                                ).toLocaleString()
                              }}
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentDisApprove.items.length
                                ).toLocaleString()
                              }}
                            </div>
                            <div
                              v-if="bTableStudentDisApprove.items.length <= 0"
                              class="float-right data-table-page-info"
                            >
                              0 - 0
                              {{ $t("messages.general.fromRecords") }}
                              {{
                                Number(
                                  bTableStudentDisApprove.items.length
                                ).toLocaleString()
                              }}
                            </div>
                          </template>

                          <template v-slot:head(action)="">
                            <label>{{ $t("messages.general.approve") }}</label
                            ><br />
                            <input
                              type="checkbox"
                              id="chkStudentAll"
                              @change="handleChkAll($event)"
                              :checked="
                                bTableStudentDisApprove.items.length > 0 &&
                                  bTableStudentDisApprove.items.length ==
                                    studentUnapproveList.length
                              "
                            />
                          </template>
                          <template v-slot:cell(action)="data">
                            <input
                              type="checkbox"
                              id="chkStudent"
                              :checked="false"
                              disabled
                            />
                          </template>

                          <template v-slot:cell(STUDENTCODE)="data">
                            <label v-if="data.item.RESERVECODE == 0">{{
                              data.item.STUDENTCODE
                            }}</label>
                            <label v-else style="color: red;">{{
                              data.item.STUDENTCODE
                            }}</label>
                          </template>
                          <template v-slot:cell(actionBin)="data">
                            <v-btn
                              text
                              icon
                              @click="pendingForDisApprove(data)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>

                          <template slot="table-caption">
                            <div
                              style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                            >
                              <div class="float-left">
                                <b class="mr-2">{{
                                  $t("messages.general.table.paginationinfo")
                                }}</b>
                                <b-form-select
                                  v-model="perPage"
                                  :options="perPageOptions"
                                  size="sm"
                                  style="width:70px"
                                />
                              </div>
                              <b-pagination
                                class="float-right"
                                size="sm"
                                :total-rows="
                                  bTableStudentDisApprove.items.length
                                "
                                v-model="currentPageStudent"
                                :per-page="perPage"
                                style="padding-top: 10px"
                              />
                              <div
                                v-if="bTableStudentDisApprove.items.length > 0"
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                {{
                                  Number(
                                    currentPageStudent > 1
                                      ? (currentPageStudent - 1) * perPage + 1
                                      : currentPageStudent
                                  ).toLocaleString()
                                }}
                                -
                                {{
                                  Number(
                                    currentPageStudent * perPage >
                                      bTableStudentDisApprove.items.length
                                      ? bTableStudentDisApprove.items.length
                                      : currentPageStudent * perPage
                                  ).toLocaleString()
                                }}
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentDisApprove.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                              <div
                                v-if="bTableStudentDisApprove.items.length <= 0"
                                class="float-right data-table-page-info"
                                style="padding-top: 14px"
                              >
                                0 - 0
                                {{ $t("messages.general.fromRecords") }}
                                {{
                                  Number(
                                    bTableStudentDisApprove.items.length
                                  ).toLocaleString()
                                }}
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </v-card>
                    </v-sheet>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </form>
      </div>
    </div>

    <v-dialog
      v-model="dialogSearchProgram"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchProgram = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartCourseProgram()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmSave"
      hide-overlay
      scrollable
      max-width="50%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>info</v-icon>
          <v-toolbar-title
            >{{ $t("messages.general.confirm")
            }}{{ $t("messages.general.studentAmount") }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSave = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.approveAmount") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    {{
                      this.bTableStudentPendingApproval.items.filter(
                        (i) => i.selCheck == true
                      ).length
                    }}
                  </div>
                </div>
              </div>
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.notapproveAmount") }}</label>
                </div>
                <div class="col no-margin-padding">
                  <div>
                    {{
                      this.bTableStudentPendingApproval.items.filter(
                        (i) => i.selCheck == false
                      ).length
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  class="btn btn-primary btn-lg"
                  type="button"
                  @click="confirmTotal()"
                >
                  {{ $t("messages.general.save") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  class="btn btn-light btn-lg"
                  type="button"
                  @click="dialogConfirmSave = false"
                >
                  {{ $t("messages.general.cancel") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "appReqLateRegis",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
  },
  data() {
    return {
      dialogSearchProgram: false,
      dialogSelected: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      selExReq: "0",
      selConfirm: "0",
      selApprove: "0",
      courseId: "",
      courseCode: "",
      courseName: "",
      sections: [],
      items: [],
      mode: "",
      studentUnapproveList: [],
      studentPendingList: [],
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAMEENG",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "CLASSTIME",
            label: this.$t("messages.general.dateClassTime"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "OFFICER",
            label: this.$t("messages.general.teachers"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "TOTALSEAT",
            label: this.$t("messages.general.receiveAmount"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "ENROLLSEAT",
            label: this.$t("messages.general.regisAmount"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "STD_REQUEST",
            label: this.$t("messages.general.reqAmount"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "APPROVE_STD",
            label: this.$t("messages.general.approveAmount"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "NOT_APPROVE_STD",
            label: this.$t("messages.general.notapproveAmount"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "ENROLL_COUNT",
            label: this.$t("messages.general.regisAmountInLate"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudentDisApprove: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "actionBin",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELGROUP",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp ",
            sortable: true,
          },
          {
            key: "APPROVE_STATUS",
            label: this.$t("messages.general.approveStatus"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "TIMEFLAG",
            label: this.$t("messages.general.periodRequest"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: this.$t("messages.general.approve"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp col-50",
            sortable: true,
          },
          {
            key: "REG_STATUS",
            label: this.$t("messages.general.enrollStatusStudy"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudentPendingApproval: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELGROUP",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "APPROVE_STATUS",
            label: this.$t("messages.general.approveStatus"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "TIMEFLAG",
            label: this.$t("messages.general.periodRequest"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: this.$t("messages.general.approve"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "REG_STATUS",
            label: this.$t("messages.general.enrollStatusStudy"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudentApprove: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "actionBin",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELGROUP",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "APPROVE_STATUS",
            label: this.$t("messages.general.approveStatus"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "TIMEFLAG",
            label: this.$t("messages.general.periodRequest"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: this.$t("messages.general.approve"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "REG_STATUS",
            label: this.$t("messages.general.enrollStatusStudy"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      extraReg: false,
      extraRegVal: false,
      selectedClsId: 0,
      dialogConfirmSave: false,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      //isStudentSelect: true,
      dialogStudents: false,
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      tmpStudentList: [],
      tmpStudentIdList: [],
      totalSumSeat: "",
      isEditTotalSumSeat: false,
      dialogRandom: false,
      randomType: "AC",
      totalConfirmDisabled: false,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.selExReq = "0";
    this.selConfirm = "0";
    this.selApprove = "0";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (
            result.data.length == 1 ||
            result.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(result.data[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    handleClrCourse() {
      this.courseId = "";
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseId = item.COURSEID;
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    handleChkAll(e) {
      const isChecked = e.target.checked;
      this.bTableStudentDisApprove.items.map((i) => {
        i.selCheck = isChecked;
        if (isChecked) {
          this.studentUnapproveList.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.studentUnapproveList = [];
      }
    },
    handleChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStudentDisApprove.items.forEach((e) => {
        if (e.rowNumber == item.rowNumber) {
          e.selCheck = isChecked;
        }
      });
      if (isChecked) {
        this.studentUnapproveList.push(item.STUDENTID);
      } else {
        const newArr = this.studentUnapproveList.filter(
          (s) => s != item.STUDENTID
        );
        this.studentUnapproveList = newArr;
      }
    },
    handleChkAllPending(e) {
      const isChecked = e.target.checked;
      this.bTableStudentPendingApproval.items.map((i) => {
        i.selCheck = isChecked;
        if (isChecked) {
          this.studentPendingList.push(i.STUDENTID);
        }
      });
      if (!isChecked) {
        this.studentPendingList = [];
      }
    },
    handleChkPending(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStudentPendingApproval.items.forEach((e) => {
        if (e.rowNumber == item.rowNumber) {
          e.selCheck = isChecked;
        }
      });
      if (isChecked) {
        this.studentPendingList.push(item.STUDENTID);
      } else {
        const newArr = this.studentPendingList.filter(
          (s) => s != item.STUDENTID
        );
        this.studentPendingList = newArr;
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);

        //แปลงค่า coursecode จากหน้าจอฟิวรายวิชากรณีไม่ได้กด enter หรือปุ่มแว่นขยาย ให้เป็นค่า courseid เพื่อนำค่าส่งไปยังปุ่มค้นหา
        if (this.courseCode != "") {
          this.togglePreLoader(true);
          const reg = await enrollProvider.getCourseByAcad({
            token: this.token,
            request: {
              coursecode: this.courseCode,
              acadyear: this.selYear,
              semester: this.selSemester,
              levelid: this.selLvl,
              lang: this.currentLang,
            },
          });
          if (reg.code != 500 && reg.data.length > 0) {
            if (
              reg.data.length == 1 ||
              reg.data[0].COURSECODE == this.courseCode
            ) {
              this.handleSelectClass(reg.data[0]);
            }
          }
        }
        const result = await enrollProvider.adjustapprovesel({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            courseid: this.courseId != "" ? this.courseId : this.courseCode,
            section: this.selSection,
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          this.searched = true;
          let idx = 0;
          result.map((d) => {
            // d.rowNumber = idx + 1;
            // this.bTable.items.push(d);
            // idx++;
            d.rowNumber = idx + 1;
            if (d.CLASSTIME) {
              d.CLASSTIME = d.CLASSTIME.replace(/\|/g, "<br/>");
            }
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      }
    },
    async getReqConfirmDetail() {
      this.togglePreLoader(true);
      this.selTab = "tab-pendingApprove";
      const result = await enrollProvider.adjustapprovelate({
        token: this.token,
        request: {
          classid: this.selected.CLASSID,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (result.length > 0) {
        this.selectedDetail = result[0];
        this.bTableStudentDisApprove.items = [];
        this.bTableStudentApprove.items = [];
        this.bTableStudentPendingApproval.items = [];
        const tempApprove = result
          .filter((i) => i.APPROVE_FLAG == "Y")
          .map((r, index) => {
            return {
              rowNumber: index + 1,
              selCheck: false,
              ...r,
            };
          });
        const tempPendingApproval = result
          .filter((i) => i.APPROVE_FLAG == "P")
          .map((r, index) => {
            return {
              rowNumber: index + 1,
              selCheck: false,
              ...r,
            };
          });
        const tempDisApprove = result
          .filter((i) => i.APPROVE_FLAG == "N")
          .map((r, index) => {
            return {
              rowNumber: index + 1,
              selCheck: false,
              ...r,
            };
          });
        this.studentPendingList = [];
        this.studentUnapproveList = [];
        this.bTableStudentDisApprove.items = tempDisApprove;
        this.bTableStudentApprove.items = tempApprove;
        this.bTableStudentPendingApproval.items = tempPendingApproval;
        this.isEdit = true;
      }
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrCourse();
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
    },
    goTo(item, index, mode) {
      this.selected = item;
      this.selectedIdx = index;
      this.getReqConfirmDetail();
      this.mode = mode;
      this.isEdit = true;
    },
    async handleSaveApproveLate() {
      this.dialogConfirmSave = true;
    },
    async confirmTotal() {
      const tempLstApprove = this.bTableStudentPendingApproval.items
        .filter((i) => i.selCheck == true)
        .map((ii) => ii.PRE_REG_DTL_ID);
      const tempLstUnApprove = this.bTableStudentPendingApproval.items
        .filter((i) => i.selCheck == false)
        .map((ii) => ii.PRE_REG_DTL_ID);
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const tempApReq = {
        token: this.token,
        request: {
          preregdtlid_list: tempLstApprove,
          approveflag: "Y",
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const tempApUnReq = {
        token: this.token,
        request: {
          preregdtlid_list: tempLstUnApprove,
          approveflag: "N",
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      let apResult = true;
      let unapResult = true;
      let msgSuccess = "";
      if (tempLstApprove.length > 0) {
        const resultAp = await enrollProvider.saveAdjustapprovelate(tempApReq);
        if (resultAp.status != 200) {
          apResult = false;
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${resultAp.message}`;
        } else {
          msgSuccess = resultAp.message;
        }
      }
      if (tempLstUnApprove.length > 0) {
        const resultUnAp = await enrollProvider.saveAdjustapprovelate(
          tempApUnReq
        );
        if (resultUnAp.status != 200) {
          unapResult = false;
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${resultUnAp.message}`;
        } else {
          msgSuccess = resultUnAp.message;
        }
      }
      if (apResult || unapResult) {
        this.dialogConfirmSuccess = true;
        this.successText = `${msgSuccess}<br/>`;
        this.getReqConfirmDetail();
        this.dialogConfirmSave = false;
      }
      this.togglePreLoader(false);
    },
    goBack() {
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      this.isEdit = false;
      this.dialogRandom = false;
      this.handleSearchConfirmResult();
      this.mode = "";
      this.studentUnapproveList = [];
    },
    handleShowDlgSearchCourse() {
      this.cleartCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      //if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
    },
    async pendingForApprove(data) {
      //กด icon bin หน้ารายชื่อ tab อนุมัติ
      this.togglePreLoader(true);
      const { item } = data;
      const tmpList = [];
      tmpList.push(item.PRE_REG_DTL_ID);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          preregdtlid_list: tmpList,
          approveflag: "P",
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.saveAdjustapprovelate(temp);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
        this.getReqConfirmDetail();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    async pendingForDisApprove(data) {
      //กด icon bin หน้ารายชื่อ tab ไม่อนุมัติ
      this.togglePreLoader(true);
      const { item } = data;
      const tmpList = [];
      tmpList.push(item.PRE_REG_DTL_ID);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          preregdtlid_list: tmpList,
          approveflag: "P",
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.saveAdjustapprovelate(temp);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
        this.getReqConfirmDetail();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    cleartCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectClass(item); //ส่งค่า courseid ปุ่มฟ้า
      await this.getSections();
      this.dialogSearchProgram = false;
    },
  },
  watch: {
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAMEENG",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "CLASSTIME",
          label: this.$t("messages.general.dateClassTime"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "OFFICER",
          label: this.$t("messages.general.teachers"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "TOTALSEAT",
          label: this.$t("messages.general.receiveAmount"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "ENROLLSEAT",
          label: this.$t("messages.general.regisAmount"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "STD_REQUEST",
          label: this.$t("messages.general.reqAmount"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "APPROVE_STD",
          label: this.$t("messages.general.approveAmount"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "NOT_APPROVE_STD",
          label: this.$t("messages.general.notapproveAmount"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "ENROLL_COUNT",
          label: this.$t("messages.general.regisAmountInLate"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudentDisApprove.fields = [
        {
          key: "actionBin",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELGROUP",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "APPROVE_STATUS",
          label: this.$t("messages.general.approveStatus"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "TIMEFLAG",
          label: this.$t("messages.general.periodRequest"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: this.$t("messages.general.approve"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "REG_STATUS",
          label: this.$t("messages.general.enrollStatusStudy"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudentPendingApproval.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELGROUP",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "APPROVE_STATUS",
          label: this.$t("messages.general.approveStatus"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "TIMEFLAG",
          label: this.$t("messages.general.periodRequest"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: this.$t("messages.general.approve"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "REG_STATUS",
          label: this.$t("messages.general.enrollStatusStudy"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudentApprove.fields = [
        {
          key: "actionBin",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELGROUP",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "APPROVE_STATUS",
          label: this.$t("messages.general.approveStatus"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "TIMEFLAG",
          label: this.$t("messages.general.periodRequest"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: this.$t("messages.general.approve"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "REG_STATUS",
          label: this.$t("messages.general.enrollStatusStudy"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
    },
  },
};
</script>
